import { useMutation } from "@apollo/client";

import type {
  AnnotationInput,
  AddAnnotationMutation,
  AddAnnotationMutationVariables,
} from "../../../API";
import { ADD_ANNOTATION } from "../../../common/operations/mutations";

export const useCreateAnnotation = () => {
  const [saveAnnotation, { data, loading }] = useMutation<
    AddAnnotationMutation,
    AddAnnotationMutationVariables
  >(ADD_ANNOTATION);

  const createAnnotation = async (input: AnnotationInput) => {
    return await saveAnnotation({
      variables: {
        input,
      },
      // Do not cache.modify getAnnotations here: it runs for every cached
      // getAnnotations(variables) and appends the new row to all of them,
      // so other zones' lists (and edit UI) show the wrong AUTOFOCUS_RECT.
      // Refetch active GetAnnotations queries so zone overview / canvas see the new row.
      refetchQueries: ["GetAnnotations"],
    });
  };

  return { createAnnotation, data, loading };
};
